<template>
    <div class="card-deck multi-select">
        <div class="card">
            <div class="card-header">
                <div>
                    <ul v-if="groups.length > 0" class="multi-select-filter list-unstyled mb-0">
                        <custom-filter-component
                            :changeFilter="changeGroup"
                            :config="filterConfig" />
                    </ul>
                    <div v-else class="card-header-title"><b>Available</b></div>
                    <input v-on:input="filterUnselected"
                        type="search"
                        class="form-control float-right"
                        placeholder="Search..."
                        role="combobox"
                        style="width: 40%;"/>
                </div>
            </div>
            <div v-if="initialized" class="list-group">
                <div v-for="item in filteredUnselected" :key="item.id"
                    class="list-group-item list-group-item-action">
                        <span class="list-group-item-label">{{ __(item.fullname || item.name, ['titleCase']) }}</span>
                        <button v-if="_.includes(unselectedProcessingIds, item.id)" type="button" disabled
                            :class="['btn', 'btn-light', 'btn-rounded', 'btn-sm', 'float-right_', 'btn-arrow']">
                            <i class="material-icons">more_horiz</i>
                        </button>
                        <button v-else type="button" v-on:click="select(item)"
                            :class="['btn', 'btn-light', 'btn-rounded', 'btn-sm', 'float-right_', 'btn-arrow']">
                            <i class="material-icons">arrow_forward</i>
                        </button>
                </div>
            </div>
            <div style="margin: 3rem auto" v-else>
                <vue-spinner></vue-spinner>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <div>
                    <div class="card-header-title"><b>Selected</b></div>
                    <input v-on:input="filterSelected"
                        type="search"
                        class="form-control float-right"
                        placeholder="Search..."
                        role="combobox"
                        style="width: 40%;"/>
                </div>
            </div>
            <draggable
                v-model="selected"
                v-on:end="changePriority"
                :options="{ 'disabled': !priorityField }"
                class="list-group">
                <div v-for="item in filteredSelected"  href="javascript:void(0)" target="_self" :key="item.id"
                    class="list-group-item list-group-item-action">
                    <i v-if="priorityField" class="material-icons drag-icon">view_headline</i>
                    <!-- <img :src="'/asset/' + item.image + '/w50-h50'" /> -->
                    <span class="list-group-item-label">{{ __(item.fullname || item.name, ['titleCase']) }}</span>
                    <!-- <br/><i>{{item.description}}</i> -->
                    <button v-if="_.includes(selectedProcessingIds, item.id)" type="button" disabled
                        :class="['btn', 'btn-light', 'btn-rounded', 'btn-sm', 'float-right', 'btn-arrow']">
                        <i class="material-icons">more_horiz</i>
                    </button>
                    <button v-else type="button" v-on:click="deselect(item)"
                        class="btn btn-light btn-rounded btn-sm float-right_ btn-arrow">
                        <i class="material-icons">arrow_back</i></button>
                    </div>
            </draggable>
        </div>
    </div>
</template>

<script>
import V from 'voca';
import _ from 'lodash';
import { singular } from 'pluralize';
import Draggable from 'vuedraggable';

import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import CustomFilterComponent from './CustomFilterComponent';

export default {
    data() {
        return {
            selected: [],
            selectedProcessingIds: [],
            unselected: [],
            unselectedProcessingIds: [],
            available: [],
            selectedFilter: null,
            unselectedFilter: null,
            currentGroup: null,
            initialized: false,
        }
    },

    props: ['type', 'parent', 'schema', 'selectedItems', 'updateBatch', 'timestamp', 'onInitialized'],

    components: {
        CustomFilterComponent,
        Draggable,
        VueSpinner: MoonLoader,
    },

    mounted() {
        this.onInitialized(this.type, 'multi-select-component', {});
        const selectedIds = (this.selectedItems || []).map(item => item.id);
        const key = this.parent.type + '.' + this.type;
        const config = this.config(['multiSelect', key], {});

        let available = [];
        let priorityField;

        this.helpers('api').getData(`/${this.type}/_ref_`)
            .then(response => {
                const available = response.data;
                const selected = available
                    .filter(item => selectedIds.indexOf(item.id) >= 0)
                    .map(item => {
                        const selectedItem = this.selectedItems
                            .find(selectedItem => selectedItem.id == item.id);
                        if (selectedItem && selectedItem.meta.priority_pivot) {
                            priorityField = selectedItem.meta.priority_pivot;

                            return { ...item, [priorityField]: selectedItem.attributes[priorityField] };
                        }
                        return item;
                    })
                    .sort((item1, item2) => item1[priorityField] > item2[priorityField] ? 1 : -1)
                const unselected = available.filter(item => selectedIds.indexOf(item.id) < 0);
                this.available = available;
                this.selected = selected;
                this.unselected = unselected;
                this.initialized = true;
            })
    },

    watch: {
        selectedItems(value) {
            const selectedIds = (this.selectedItems || []).map(item => item.id);
            this.selected = this.available
                .filter(item => {
                    let pass = true;
                    pass = selectedIds.indexOf(item.id) >= 0;
                    return pass;
                })
                .map(item => {
                    const selectedItem = value.find(selectedItem => selectedItem.id == item.id);
                    if (this.priorityField) {
                        return {
                            ...item,
                            [this.priorityField]: selectedItem.attributes[this.priorityField]
                        };
                    }
                    return item;
                })
                .sort((item1, item2) => item1[this.priorityField] > item2[this.priorityField] ? 1 : -1);

            this.unselected = this.available
                .filter(item => {
                    let pass = true;
                    pass = selectedIds.indexOf(item.id) < 0;
                    return pass;
                })
        },

        selectedFilter() {
            this.$forceUpdate();
        }
    },

    computed: {
        priorityField() {
            if (this.selectedFilter) return null;
            return _.get(this.selectedItems, '[0].meta.priority_pivot');
        },

        filteredSelected() {
            return this.selected
                .filter(item => {
                    let pass = true;
                    if (this.selectedFilter) {
                        pass = _.chain([item.name, item.fullname, item.description])
                            .filter()
                            .map(_.toLower)
                            .join(' ')
                            .value()
                            .search(_.toLower(this.selectedFilter)) >= 0;
                    }
                    if (this.multiSelectConfig.groupBy && this.currentGroup) {
                        pass = item[this.multiSelectConfig.groupBy] == this.currentGroup;
                    }
                    return pass;
                })
        },

        filteredUnselected() {
            return this.unselected
                .filter(item => {
                    let pass = true;
                    if (this.unselectedFilter) {
                        pass = _.chain([item.name, item.fullname, item.description])
                            .filter()
                            .map(_.toLower)
                            .join(' ')
                            .value()
                            .search(_.toLower(this.unselectedFilter)) >= 0;
                    }
                    if (this.multiSelectConfig.groupBy && this.currentGroup) {
                        pass = item[this.multiSelectConfig.groupBy] == this.currentGroup;
                    }
                    return pass;
                })
        },

        multiSelectConfig() {
            const key = this.parent.type + '.' + this.type;
            return this.config(['multiSelect', key], {});

        },

        groups() {
            const { groupBy } = this.multiSelectConfig;
            if (!groupBy) return [];

            return _.chain(this.available)
                .map(ref => ref[groupBy])
                .uniq()
                .map(value => ({ id: value, name: V.titleCase(value) }))
                .value();
        },

        filterConfig() {
            return {
                key: this.multiSelectConfig.groupBy,
                name: 'Group',
                values: this.groups,
            }
        }
    },

    methods: {
        select(item) {
            this.$emit('item-select', item);
            this.unselectedProcessingIds.push(item.id);
            this.updateBatch([
                { id: item.id, $attach: true },
            ]).then(() => {
                this.unselectedProcessingIds = _.reject(this.unselectedProcessingIds, (id) => id == item.id);
                this.$forceUpdate();
            });
        },

        deselect(item) {
            this.$emit('item-deselect', item);
            this.selectedProcessingIds.push(item.id);
            this.updateBatch([
                { id: item.id, $detach: true },
            ]).then(() => {
                this.selectedProcessingIds = _.reject(this.selectedProcessingIds, (id) => id == item.id);
                this.$forceUpdate();
            });
        },

        filterSelected(e) {
            const { value } = e.target;
            this.selectedFilter = value;
        },

        filterUnselected(e) {
            const { value } = e.target;
            this.unselectedFilter = value;
        },

        changeGroup(__, value) {
            this.currentGroup = value;
        },

        getDiffItems(selected, available) {
            const selectedIds = selected.map(item => item.id);
            const unselected = available.filter(item => selectedIds.indexOf(item.id) < 0);
            return unselected;
        },

        changePriority(event) {
            const { oldIndex, newIndex } = event;
            if (oldIndex === newIndex) return;

            const [lesserIndex, greaterIndex] = oldIndex < newIndex ? [oldIndex, newIndex] : [newIndex, oldIndex];

            const changedItems = this.selected.slice(lesserIndex, greaterIndex + 1);
            const changedItemIds = changedItems.map(item => item.id);

            const orderedPriorities = changedItems.map(item => item[this.priorityField]).slice().sort((value1, value2) => {
                if (parseInt(value1) > parseInt(value2)) return 1;
                return -1;
            });

            const updatedData = _.zip(changedItemIds, orderedPriorities)
                .map(([id, priority]) => ({ id, $update:{ [this.priorityField]: priority } }))

            this.updateBatch(updatedData, {
                setNotification: true,
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/MultiSelectComponent.vue